import type { SearchResultEvent } from '../../data/schema/SubstrateSearchResponse';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import type CalendarItemTypeType from 'owa-service/lib/contract/CalendarItemTypeType';
import {
    convertRecipientToSingleRecipientType,
    convertToFolderId,
    convertToItemId,
    convertSearchSortOrder,
} from './converterHelpers';
import { getAccountScopeUserSettings } from 'owa-session-store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

const DEFAULT_ITEMCLASS: string = 'IPM.Appointment';

export default function convertSearchResultEventToCalendarItemType(
    searchResult: SearchResultEvent
): CalendarItem {
    const organizer = searchResult?.Organizer
        ? convertRecipientToSingleRecipientType(searchResult.Organizer)
        : undefined;
    return {
        CalendarItemType: searchResult?.CalendarItemType
            ? (searchResult.CalendarItemType.toString() as CalendarItemTypeType)
            : undefined,
        Categories: searchResult.Categories,
        CharmId: searchResult.Charm,
        DisplayTo: searchResult.DisplayTo,
        End: searchResult.End,
        Start: searchResult.Start,
        HasAttachments: searchResult.HasAttachments,
        IsAllDayEvent: searchResult.IsAllDayEvent,
        IsMeeting: searchResult.IsMeeting,
        IsMeetingPollEvent: searchResult.IsMeetingPollEvent,
        ItemClass: searchResult.ItemClass ? searchResult.ItemClass : DEFAULT_ITEMCLASS,
        FreeBusyType: searchResult.LegacyFreeBusyStatus
            ? searchResult.LegacyFreeBusyStatus.toString()
            : undefined,
        Location: { DisplayName: searchResult.Location },
        Sensitivity: searchResult.Sensitivity,
        SeriesId: searchResult.SeriesMasterItemId ? searchResult.SeriesMasterItemId.Id : undefined,
        Subject: searchResult.Subject,
        Organizer: organizer,
        UID: searchResult.UID,
        ItemId: searchResult?.ItemId ? convertToItemId(searchResult.ItemId) : undefined,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (49,9): Type 'import("packages/framework/owa-graph-schema/lib/__generated__/schema.all.interface").FolderId' is not assignable to type 'import("C:/Users/loicbe/workspace/client-web/shared/internal/owa-service/lib/contract/FolderId").default'.
        // @ts-expect-error
        ParentFolderId: searchResult?.ParentFolderId
            ? convertToFolderId(searchResult.ParentFolderId)
            : undefined,
        SerializedImmutableId: searchResult.ImmutableId,
        SortOrderSource: searchResult?.SortOrderSource
            ? convertSearchSortOrder(searchResult.SortOrderSource)
            : undefined,
        Preview: searchResult.Preview,
        // sometimes 3S is wrong about whether you're the organizer, so also check organizer mailbox info
        IsOrganizer:
            searchResult.IsOrganizer &&
            getAccountScopeUserSettings(getModuleContextMailboxInfo()).SessionSettings
                ?.UserEmailAddress === organizer?.Mailbox?.EmailAddress,
        IsCancelled: searchResult.IsCancelled,
        ResponseType: searchResult.MyResponseType,
    };
}
